var React = require('react');

function DotsHorizontal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":" M 8 12.055 C 8.016 13.159 7.132 14.067 6.028 14.082 C 4.923 14.097 4.016 13.214 4.001 12.11 C 3.986 11.005 4.869 10.098 5.973 10.082 C 7.078 10.067 7.985 10.95 8 12.055 Z  M 14 11.973 C 14.015 13.077 13.132 13.985 12.027 14 C 10.923 14.015 10.015 13.132 10 12.027 C 9.985 10.923 10.868 10.015 11.973 10 C 13.077 9.985 13.985 10.868 14 11.973 Z  M 19.999 11.89 C 20.014 12.995 19.131 13.902 18.027 13.918 C 16.922 13.933 16.015 13.05 16 11.945 C 15.984 10.841 16.868 9.933 17.972 9.918 C 19.077 9.903 19.984 10.786 19.999 11.89 Z "}));
}

DotsHorizontal.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"4.001 9.918 15.999 4.164","width":"15.999","height":"4.164"};

module.exports = DotsHorizontal;

DotsHorizontal.default = DotsHorizontal;
